import { AddOutlined, CancelOutlined, Delete, Edit, Visibility, VisibilityOff } from '@mui/icons-material';
import { Autocomplete, Box, Button, Drawer, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Select, Switch, TextField, Typography } from '@mui/material'
import { FormikValues, useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { Form } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { ApiAddAreaManager, ApiCreateVenueLogins, ApiDeleteAreaManager, ApiDeleteVenueLogins, ApiGenerateLoginToken, ApiGetAreaManager, ApiGetVenueList, ApiGetVenueLogins, ApiRegionVenues, ApiUpdateAreaManager, ApiUpdateVenueLogins } from '../../apiService/Core/Apicall';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../global/config/Reducer';
import { veneuLogins } from '../../apiService/Core/ApiEndPoint';
import { RegionList, setRegion } from '../../global/config/Reducer/RegionSlice';
import storage from '../../utils/storage';


function ManageArea() {
    const [selectedId, setselectedId] = useState<null | number>(null)
    // const [selectedmanager, setselectedmanager] = useState(0)
    const [searchVenue, setsearchVenue] = useState<string>('')
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [isOpenAdd, setisOpenAdd] = useState(false);
    const [isedit, setisedit] = useState(false);
    // const [venuemanagerlist, setvenuemanagerlist] = useState<any[]>([])
    const [Areamanagerlist, setareamanagerlist] = useState<any[]>([])
    const [venues, setvenuelist] = useState<any[]>([])
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
    const userData = JSON.parse(storage.getItem("userData") || "{}");
    const Regions = useSelector(RegionList)
    const dispatch = useDispatch()
    const [selectedRegion, setselectedRegion] = useState<number | ''>(Regions[0]?.regionId ?? '')
    const [isGroupScore, setisGroupScore] = useState<boolean>(false);
    const { clientEntityIds } = useSelector((state: RootState) => state.wholegroup)


    useEffect(() => {
        const RegionList = async () => {
            if (storage.getItem("clientEntityId") && storage.getItem('ClientGroupName') === "ALDI") {
                const data = `?clientEntityId=${storage.getItem("clientEntityId")}`
                const response3 = await ApiRegionVenues(data)
                dispatch(setRegion(response3.data))
            }
        }
        RegionList()
    }, [clientEntity])

    useEffect(() => {
        if (Regions.length > 0) {
            setselectedRegion(Regions[0].regionId);
        }
    }, [Regions, clientEntity]);

    useEffect(() => {
        const Venuelist = async () => {
            if (!window.location.hostname.includes('aldi')) {
                try {
                    const clientEntityId: any = isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')
                    const response = await ApiGetVenueList(clientEntityId);
                    console.log(response)
                    setvenuelist(response.data);

                } catch (error: any) {
                    // toast.error(error)
                }
            }
            else {
                const finalregion = Regions && Regions.find((region: any) => region.regionId === selectedRegion)?.venues;
                setvenuelist(finalregion)
            }

        };
        clientEntity && Venuelist();

    }, [clientEntity, selectedRegion, Regions, isGroupScore])

    const fetchAreaManagers = async () => {
        try {
            const data = `?offset=0&limit=1000&clientEntityId=${isGroupScore ? clientEntityIds : clientEntity}`
            const response = await ApiGetAreaManager(data)
            setareamanagerlist(response.data)
        } catch (error) {
            console.error('Error fetching area managers:', error)
        }
    }
    useEffect(() => {

        clientEntity && fetchAreaManagers()
    }, [clientEntity, isGroupScore])


    // const venuelogins = async () => {
    //     try {
    //         const data = `?venueId=${venuelist[selectedId].venueId}`
    //         const res = await ApiGetVenueLogins(data)
    //         if (res.status) {
    //             setvenuemanagerlist(res.data)
    //         }

    //     } catch (error: any) {
    //         // const message =
    //         //     error?.response?.data?.message ||
    //         //     error?.message ||
    //         //     String(error);
    //         // toast.error(message)
    //         console.log("Error", error)
    //     }
    // }

    // useEffect(() => {
    //     venuelist && venuelogins()
    // }, [venuelist, selectedId])


    const initialValues = {
        areaName: selectedId !== null ? Areamanagerlist[selectedId]?.areaName : "",
        userName: selectedId !== null ? Areamanagerlist[selectedId]?.userName : "",
        firstName: selectedId !== null ? Areamanagerlist[selectedId]?.firstName : "",
        lastName: selectedId !== null ? Areamanagerlist[selectedId]?.lastName : "",
        password: "",
        confirmpassword: "",
        email: selectedId !== null ? Areamanagerlist[selectedId]?.emailId : "",
        venueList: selectedId !== null ? Areamanagerlist[selectedId]?.venueIds ? Areamanagerlist[selectedId]?.venueIds.split(",").map((id: any) => id.trim()) : [] : [],
        isedit: isedit
    }


    const validationSchema = Yup.object({
        email: Yup.string()
            .email("Invalid email format")
            .required("Email is required"),

        password: Yup.string().when("isedit", {
            is: false,
            then: schema =>
                schema
                    .required("Password is required")
                    .min(6, "Password must be at least 6 characters")
                    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
                    .matches(/[0-9]/, "Password must contain at least one number"),
            otherwise: schema => schema.notRequired()
        }),

        confirmpassword: Yup.string().when("isedit", {
            is: false,
            then: schema =>
                schema
                    .required("Confirm Password is required")
                    .oneOf([Yup.ref("password")], "Passwords must match"),
            otherwise: schema => schema.notRequired()
        }),

        // userName: Yup.string()
        //     .required("user Name is required"),

        firstName: Yup.string()
            .required("first Name is required"),
        lastName: Yup.string()
            .required("last Name is required"),

        areaName: Yup.string()
            .required("area Name is required"),

        venueList: Yup.array().min(1, "At least one venue must be selected"),

    });

    const onSubmit = async (values: FormikValues) => {
        console.log("Venue Manager Details", values)
        const formData = {
            areaName: values.areaName,
            clientEntityId: parseInt(clientEntity || '0'),
            // userName: values.userName.trim() == '' ? `${values.firstName} ${values.lastName}` : values.userName,
            clientId: parseInt(storage.getItem('clientId') || "0"),
            emailId: values.email,
            venueIds: values.venueList.join(","),
            firstName: values.firstName,
            lastName: values.lastName,
            password: values.password,
            role: 'areaManager',
            createdBy: parseInt(userData.userId)
        }

        const updatevalues =
        {
            areaId: selectedId !== null ? Areamanagerlist[selectedId].areaId : '',
            areaName: values.areaName,
            clientEntityId: clientEntity,
            // userName: values.userName.trim() == '' ? `${values.firstName} ${values.lastName}` : values.userName,
            emailId: values.email,
            venueIds: values.venueList.join(","),
            modifiedBy: Number(clientEntity)
        }
        try {
            const response = isedit ? await ApiUpdateAreaManager(updatevalues) : await ApiAddAreaManager(formData)
            if (response.status) {
                formik.resetForm()
                // isedit ? toast.success("Details updated successfully") : toast.success("VenueManager added successfully")
                setisedit(false)
                setisOpenAdd(false)
                fetchAreaManagers()
                setselectedId(null)
            }
        } catch (error: any) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                String(error);
            toast.error(message)
        }

    }

    const formik = useFormik({

        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const handleRemoveAreaManager = async (id: string | number) => {

        const isdelete = window.confirm("Are you sure you want to delete ?")
        if (isdelete) {
            try {
                const data = {
                    areaId: id
                }
                const res = await ApiDeleteAreaManager(data)
                if (res.status) {
                    fetchAreaManagers()
                }

            } catch (error: any) {
                const message =
                    error?.response?.data?.message ||
                    error?.message ||
                    String(error);
                toast.error(message)
            }
        }
    }

//     const getClientSiteURL = (hostname: any) => {
//     switch (hostname) {
//       case "ALDI":
//         return process.env.REACT_APP_ALDI;
//       case "BLOOMS":
//         return process.env.REACT_APP_BLOOMS;
//       case "MM":
//          return process.env.REACT_APP_COMMON;
//       case "TRANSPORT": // same URL for both
//         return process.env.REACT_APP_API_COMMON;
//       default:
//         return null;
//     }
//   }
//     const navigateToLoginShopper = async (user: any) => {

//         try {
//             const data = {
//                 adminUserId: userData.userId,
//                 targetUserId: user.userId,
//                 ipAddress: '127.0.0.1',
//                 browserName: 'Google chrome'

//             }
//             console.log("User---->", user)
//             console.log("CLinet URL---->",getClientSiteURL(user.clientGroupName) )
//             const res = await ApiGenerateLoginToken(data)
//             if (res.success) {
//                 window.open(`${getClientSiteURL(user.clientGroupName)}?adminuserid=${userData.userId}&validation=${res.data.token}`, '_blank');
//             }
//         } catch (error: any) {
//             toast.error(error)
//         }

//     }

    return (
        <Box className='w-100' height={'calc(100vh - 97px)'}>
            {/* {(storage.getItem("ClientGroupName") === "MM" || storage.getItem("ClientGroupName") ===  "EXTENDED" || storage.getItem("ClientGroupName") === "JBHIFI") && storage.getItem('userRole') === 'clientadmin' && (
                <Box className='d-flex justify-content-end w-100'>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={isGroupScore}
                                onChange={(e) => setisGroupScore(e.target.checked)}
                            />
                        }
                        label={"Whole Group"}
                    />
                </Box>)} */}
            <Box className='mb-3 d-flex align-items-end justify-content-between' gap={4}>
                <FormControl fullWidth className='rm-padding'>
                    <FormLabel sx={{ fontSize: "14px" }}>Search By Name</FormLabel>
                    <TextField value={searchVenue} className="w-100 border-20" onChange={(e) => { setsearchVenue(e.target.value) }}></TextField>
                </FormControl>

                <Button className='btn-main mb-1 px-3' sx={{ whiteSpace: 'nowrap' }} onClick={() => { setisOpenAdd(true); setisedit(false); }} >+ Add New</Button>
            </Box>
            <Grid container height={'calc(100% - 100px)'} spacing={3}>
                <Grid size={{ xs: 12, md: 12 }} className='h-100 p-3 border-10' overflow={"auto"} border={'1px solid #ccc'}>
                    <Grid container spacing={2} height={'fit-content'} position={'relative'} overflow={'auto'}>
                        {Areamanagerlist?.length > 0 ? Areamanagerlist
                            .filter((item) =>
                                searchVenue ? item?.areaName?.toLowerCase().includes(searchVenue?.toLowerCase()) : item)
                            .map((item, index) => (
                                <Grid size={{ xs: 12, md: 6 }} height={'fit-content'} className={`card  text-start p-1 px-3 border-10 mb-0 ms-0`} key={index}>
                                    <Box className='d-flex align-items-center py-2  mb-0'>
                                        <Box className='col-8 px-0'>
                                            <Typography className='px-0'>{item?.firstName} {item?.lastName}</Typography>
                                            <Typography className='px-0 fw-bold' variant='subtitle2'>{item?.areaName}</Typography>
                                        </Box>
                                        <IconButton className='col-1 p-0' onClick={() => { setisOpenAdd(true); setisedit(true); setselectedId(index) }}><Edit /></IconButton>
                                        <IconButton className='col-1 p-0' onClick={() => { handleRemoveAreaManager(item?.areaId) }}><Delete /></IconButton>
                                        {/* <Button className='col-2 btn-main' onClick={()=>{navigateToLoginShopper(item)}}>Login</Button> */}
                                    </Box>

                                </Grid>
                            )) : <Typography>There are no Area Managers currently listed</Typography>}

                    </Grid>
                </Grid>
            </Grid>
            <Drawer anchor='right' PaperProps={{
                sx: { width: "100%", maxWidth: '500px' }
            }} open={isOpenAdd}>
                <Box className='p-3 bg-white h-100 w-100'>
                    <Box className={'d-flex allign-items-center justify-content-between'}>
                        <Typography
                            variant='h5'
                            className='mb-0'
                            fontWeight={'bolder'}
                        >
                            {isedit ? 'Edit Area Manager' : 'Add Area Manager'}
                        </Typography>
                        <IconButton onClick={() => { setisOpenAdd(false); setisedit(false); setselectedId(null) }}><CancelOutlined /></IconButton>
                    </Box>
                    <hr />
                    <form className='w-100' onSubmit={formik.handleSubmit}>
                        <Grid container spacing={2} className='w-100'>
                            <Grid size={12}>
                                <FormControl className='rm-padding w-100'>
                                    <FormLabel sx={{ fontSize: "14px" }}>Area Name</FormLabel>
                                    <TextField
                                        name='areaName'
                                        className="w-100 border-20"
                                        value={formik.values.areaName}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}

                                    />
                                    {formik.touched.areaName && formik.errors.areaName && typeof formik.errors.areaName === "string" && (
                                        <Typography variant='caption' sx={{ color: 'red' }}>
                                            {formik.errors.areaName}
                                        </Typography>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid size={12}>
                                <FormControl className='rm-padding w-100'>
                                    <FormLabel sx={{ fontSize: "14px" }}>First Name</FormLabel>
                                    <TextField
                                        name='firstName'
                                        className="w-100 border-20"
                                        value={formik.values.firstName}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}

                                    />
                                    {formik.touched.firstName && formik.errors.firstName && typeof formik.errors.firstName === 'string' && (
                                        <Typography variant='caption' sx={{ color: 'red' }}>
                                            {formik.errors.firstName}
                                        </Typography>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid size={12}>
                                <FormControl className='rm-padding w-100'>
                                    <FormLabel sx={{ fontSize: "14px" }}>Last Name</FormLabel>
                                    <TextField
                                        name='lastName'
                                        className="w-100 border-20"
                                        value={formik.values.lastName}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}

                                    />
                                    {formik.touched.lastName && formik.errors.lastName && typeof formik.errors.lastName === 'string' && (
                                        <Typography variant='caption' sx={{ color: 'red' }}>
                                            {formik.errors.lastName}
                                        </Typography>
                                    )}
                                </FormControl>
                            </Grid>
                            {/* <Grid size={12}>
                                <FormControl className='rm-padding w-100'>
                                    <FormLabel sx={{ fontSize: "14px" }}>User Name</FormLabel>
                                    <TextField
                                        name='userName'
                                        className="w-100 border-20"
                                        value={formik.values.userName}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}

                                    />
                                    {formik.touched.userName && formik.errors.userName && typeof formik.errors.userName === 'string' && (
                                        <Typography variant='caption' sx={{ color: 'red' }}>
                                            {formik.errors.userName}
                                        </Typography>
                                    )}
                                </FormControl>
                            </Grid> */}
                            <Grid size={12}>
                                <FormControl className=' w-100 rm-padding'>
                                    <FormLabel sx={{ fontSize: "14px" }}>Manager Email</FormLabel>
                                    <TextField
                                        type='email'
                                        name='email'
                                        className="w-100 border-20"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}

                                    />
                                    {formik.touched.email && formik.errors.email && typeof formik.errors.email === 'string' && (
                                        <Typography variant='caption' sx={{ color: 'red' }}>
                                            {formik.errors.email}
                                        </Typography>
                                    )}
                                </FormControl>
                            </Grid>
                            {window.location.hostname.includes('aldi') && (
                                <Grid size={12}>
                                    <FormControl sx={{ width: '100%', minWidth: "200px", height: 'fit-content' }} >
                                        {/* <InputLabel id="demo-simple-select-label">Region</InputLabel> */}
                                        <FormLabel sx={{ fontSize: "14px" }}>Regions</FormLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            // label='Region'
                                            id="demo-simple-select"
                                            defaultValue={Regions[0]?.regionId}
                                            value={selectedRegion}
                                            onChange={(e: any) => { setselectedRegion(e.target.value) }}
                                        >
                                            {Regions?.map((item: any, index: number) => (
                                                <MenuItem key={index} value={item.regionId}>
                                                    {item.regionName}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            )}
                            <Grid size={12}>
                                <FormControl className=' w-100 rm-padding'>
                                    <FormLabel sx={{ fontSize: "14px" }}>Venue List</FormLabel>
                                    <Autocomplete

                                        multiple
                                        options={venues || []}
                                        getOptionLabel={(option) => option?.venueName || ""}
                                        value={
                                            formik?.values.venueList && venues?.length > 0
                                                ? venues.filter(
                                                    (venue) =>
                                                        formik.values.venueList.includes(venue.venueId) ||
                                                        formik.values.venueList.includes(String(venue.venueId)),
                                                )
                                                : []
                                        }
                                        onChange={(event, value) => {
                                            const selectedValues = value.map((item) => item.venueId)
                                            formik.setFieldValue("venueList", selectedValues)
                                        }}
                                        //  onBlur={formik.handleBlur}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                // label="Venue List"
                                                error={formik.touched.venueList && Boolean(formik.errors.venueList)}
                                                helperText={
                                                    formik.touched.venueList &&
                                                        typeof formik.errors.venueList === "string"
                                                        ? formik.errors.venueList
                                                        : ""
                                                } />
                                        )}
                                        fullWidth
                                    />

                                    {formik.touched.venueList && formik.errors.venueList && typeof formik.errors.venueList === 'string' && (
                                        <Typography variant='caption' sx={{ color: 'red' }}>
                                            {formik.errors.venueList}
                                        </Typography>
                                    )}
                                </FormControl>
                            </Grid>
                            {!isedit && (
                                <>
                                    <Grid size={12}>
                                        <FormControl className='w-100 rm-padding'>
                                            <FormLabel sx={{ fontSize: "14px" }}>Create Password</FormLabel>
                                            <TextField
                                                type={showPassword ? "text" : "password"}
                                                name='password'
                                                className="w-100 border-20"
                                                value={formik.values.password}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                onClick={() => setShowPassword(!showPassword)}
                                                                edge="end"
                                                            >
                                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}

                                            />
                                            {formik.touched.password && formik.errors.password && typeof formik.errors.password === "string" && (
                                                <Typography variant='caption' sx={{ color: 'red' }}>
                                                    {formik.errors.password}
                                                </Typography>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid size={12}>
                                        <FormControl className='w-100 rm-padding'>
                                            <FormLabel sx={{ fontSize: "14px" }}>Confirm Password</FormLabel>
                                            <TextField
                                                type={showConfirmPassword ? "text" : "password"}
                                                name='confirmpassword'
                                                className="w-100 border-20"
                                                value={formik.values.confirmpassword}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                                edge="end"
                                                            >
                                                                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}

                                            />
                                            {formik.touched.confirmpassword && formik.errors.confirmpassword && typeof formik.errors.confirmpassword === "string" && (
                                                <Typography variant='caption' sx={{ color: 'red' }}>
                                                    {formik.errors.confirmpassword}
                                                </Typography>
                                            )}
                                        </FormControl>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                        <Box className='d-flex justify-content-end'><Button type='submit' className='btn-main px-4 py-1 my-3'>{isedit ? 'Update' : 'Add'}</Button></Box>
                    </form>
                </Box>

            </Drawer>
        </Box>
    )
}

export default ManageArea
